'use client';

import { FC, ForwardedRef, forwardRef, useRef } from 'react';

import { useIsVisible } from 'hooks/useIsVisible';

interface IRequirements {
  title: string;
  content: string;
}

export const Requirements = forwardRef(({ title, content }: IRequirements, ref: ForwardedRef<HTMLDivElement>) => {
  const requirementsRef = useRef<HTMLDivElement>(null);
  const isVisibleRequirements = useIsVisible(requirementsRef);

  return (
    <div ref={ref}>
      <div
        ref={requirementsRef}
        className={`flex items-center justify-center p-10 gap-3.5 md:px-5 md:py-10 transition-all ${isVisibleRequirements ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-full'}`}
      >
        <div className="container !max-w-[900px]">
          <div
            className="py-9 px-5 flex flex-col gap-9 justify-between font-poppins md:p-0 md:text-center">
            <h2 className="font-semibold text-dark-blue text-4xl">{title}</h2>
            <p className="text-gray-text text-lg">{content}</p>
          </div>
        </div>
      </div>
    </div>
  );
});

Requirements.displayName = 'Requirements';
